import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import {
  Info as InfoIcon,
  ChatBubbleOutline as MessageIcon,
  ErrorOutline as FailedIcon,
} from '@mui/icons-material';

import DialogModal from '../../../../../components/DialogModal';
import MassTextCampaign from '../../../../../Model/MassTextCampaign';
import colors from '../../../../../styles/colors';
import texts from '../../texts.json';

import OverviewPanel from './OverviewPanel';
import MessagePanel from './MessagePanel';
import FailedPanel from './FailedPanel';
import { SUB_TABS } from './utils';
import { Eyebrow, SubTabs, SubTab } from './styles';

const { details } = texts.history;

const CampaignDetailsModal = ({ selected, onClose }) => {
  const [activeSubTab, setActiveSubTab] = useState(SUB_TABS.OVERVIEW);
  const lastSelectedRef = useRef(selected);
  if (selected) lastSelectedRef.current = selected;
  const displayed = lastSelectedRef.current;
  const selectedId = selected?.id;

  useEffect(() => {
    if (selectedId) setActiveSubTab(SUB_TABS.OVERVIEW);
  }, [selectedId]);

  if (!displayed) return null;

  const {
    id, data: campaign, coachName, sentByName,
  } = displayed;
  const failedTotal = MassTextCampaign.getFailedTotal(campaign?.totals);

  return (
    <DialogModal open={Boolean(selected)} onClose={onClose} maxWidth="md" fullWidth>
      <Box sx={{ p: '24px 28px 28px', minWidth: 560 }}>
        <Eyebrow>{details.eyebrow}</Eyebrow>
        <Typography
          sx={{
            fontSize: 18, fontWeight: 600, color: colors.base.beta, mb: 1,
          }}
        >
          {campaign.name || details.untitled}
        </Typography>

        <SubTabs
          value={activeSubTab}
          onChange={(_, value) => setActiveSubTab(value)}
        >
          <SubTab
            value={SUB_TABS.OVERVIEW}
            label={details.tabs.overview}
            icon={<InfoIcon fontSize="small" />}
            iconPosition="start"
          />
          <SubTab
            value={SUB_TABS.MESSAGE}
            label={details.tabs.message}
            icon={<MessageIcon fontSize="small" />}
            iconPosition="start"
          />
          <SubTab
            value={SUB_TABS.FAILED}
            label={`${details.tabs.failed} (${failedTotal})`}
            icon={<FailedIcon fontSize="small" />}
            iconPosition="start"
          />
        </SubTabs>

        {activeSubTab === SUB_TABS.OVERVIEW && (
          <OverviewPanel
            campaign={campaign}
            coachName={coachName}
            sentByName={sentByName}
          />
        )}
        {activeSubTab === SUB_TABS.MESSAGE && (
          <MessagePanel bodyTemplate={campaign.bodyTemplate} image={campaign.image} />
        )}
        {activeSubTab === SUB_TABS.FAILED && (
          <FailedPanel campaignId={id} totalFailed={failedTotal} />
        )}
      </Box>
    </DialogModal>
  );
};

CampaignDetailsModal.propTypes = {
  selected: PropTypes.shape({
    id: PropTypes.string.isRequired,
    data: PropTypes.shape({
      name: PropTypes.string,
      bodyTemplate: PropTypes.string,
      image: PropTypes.string,
      totals: PropTypes.object,
    }).isRequired,
    coachName: PropTypes.string,
    sentByName: PropTypes.string,
  }),
  onClose: PropTypes.func.isRequired,
};

CampaignDetailsModal.defaultProps = {
  selected: null,
};

export default CampaignDetailsModal;
